class DrinkCalculator extends HTMLElement {
  constructor() {
    super();

    this.wineAmountInput = this.querySelector('input[name="drink_calculator[wine_amount]"]');
    this.beerAmountInput = this.querySelector('input[name="drink_calculator[beer_amount]"]');
    this.spiritsAmountInput = this.querySelector('input[name="drink_calculator[spirits_amount]"]');

    this.wineAmountRange = this.querySelector('input[name="drink_calculator[wine_amount_range]"]');
    this.beerAmountRange = this.querySelector('input[name="drink_calculator[beer_amount_range]"]');
    this.spiritsAmountRange = this.querySelector('input[name="drink_calculator[spirits_amount_range]"]');

    this.isChampagneToastCheckbox = this.querySelector('#DrinkCalculator-isChampagneToast');
    this.numberOfGuestsInput = this.querySelector('#DrinkCalculator-NumberOfGuests');
    this.eventLengthInput = this.querySelector('#DrinkCalculator-EventLength');
    this.eventLengthRange = this.querySelector('input[name="drink_calculator[event_length_range]"]');
    this.hourUnitLabel = this.querySelector('.hour-unit');

    this.resultsPlaceholderTotalDrinks = this.querySelector('.results-container .placeholder-total-drinks');
    this.resultsPlaceholderDrinksPerGuest = this.querySelector('.results-container .placeholder-drinks-per-guest');
    this.resultsPlaceholderWineCount = this.querySelector('.results-container .placeholder-wine-count');
    this.resultsPlaceholderSpiritsCount = this.querySelector('.results-container .placeholder-spirits-count');
    this.resultsPlaceholderBeerCount = this.querySelector('.results-container .placeholder-beer-count');
    this.resultsPlaceholderChampagneCount = this.querySelector('.results-container .placeholder-champagne-count');


    this.initializeCustomRangeComponent();
    this.initializeInputValueUpdateProcess();
    this.handleLockSelection();

    this.calculate();
  }

  handleLockSelection() {
    const lockCheckboxes = this.querySelectorAll('input.locked[type="checkbox"]');
    lockCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          lockCheckboxes.forEach((checkbox) => {
            if (checkbox !== e.target) {
              checkbox.checked = false;
            }
          });
        }
      });
    });
  }

  onRangeInput(e) {
    if (e.target.name === this.eventLengthRange.name) {
      // Convert from scale 0-100 to 1-12 hours
      const hours = Math.round((parseInt(e.target.value) / 100) * 12);
      const displayValue = Math.max(1, Math.min(12, hours));

      this.eventLengthInput.value = displayValue;

      if (this.hourUnitLabel) {
        this.hourUnitLabel.textContent = this.formatHours(displayValue);
      }

      this.calculate();
      return;
    }

    const w = this.wineAmountRange;
    const b = this.beerAmountRange;
    const s = this.spiritsAmountRange;

    const wi = this.wineAmountInput;
    const bi = this.beerAmountInput;
    const si = this.spiritsAmountInput;

    const locked = this.querySelector('input.locked[type="checkbox"]:checked');

    e.target.parentNode.parentNode.querySelector('input[type="number"]').value = e.target.value;

    const map = {
      'drink_calculator[wine_amount_range]': 'wine',
      'drink_calculator[beer_amount_range]': 'beer',
      'drink_calculator[spirits_amount_range]': 'spirits',
    };

    const mapToRangeFields = {
      wine: w,
      beer: b,
      spirits: s,
    };

    const mapToInputFields = {
      wine: wi,
      beer: bi,
      spirits: si,
    };

    if (locked) {
      const lockedValue = parseInt(mapToInputFields[locked.value].value);
      const newMax = 100 - lockedValue;

      Object.keys(mapToRangeFields).filter(key => key !== locked.value).forEach((key) => {
        mapToRangeFields[key].dataset.limit = newMax;
      });
    } else {
      Object.keys(mapToRangeFields).forEach((key) => {
        mapToRangeFields[key].dataset.limit = 100;
      });
    }

    const newValue = parseInt(e.target.value);
    const updatedType = map[e.target.name];

    if (newValue === 100) {
      Object.keys(mapToRangeFields).filter(key => key !== updatedType).forEach((key) => {
        mapToRangeFields[key].value = 0;
        mapToInputFields[key].value = 0;
      });

      $('input[type="range"]').rangeslider('update', true);
      this.calculate();
      return;
    }

    let newSum = newValue;

    Object.keys(mapToRangeFields).filter(key => key !== updatedType).forEach((key) => {
      newSum += parseInt(mapToRangeFields[key].value);
    });

    const diff = 100 - newSum;

    Object.keys(mapToRangeFields)
      .filter(key => key !== updatedType)
      .filter(key => Number(mapToRangeFields[key].value) !== 0 || diff > 0)
      .filter(key => !locked || locked?.value !== key)
      .forEach((key, index, array) => {
        const newValue = Number(mapToRangeFields[key].value) + (diff / array.length);
        if (newValue >= 0) {
          mapToRangeFields[key].value = newValue;
          mapToInputFields[key].value = index % 2 === 0 ? newValue.toFixed(0) : Math.floor(newValue);
        }
      });

    $('input[type="range"]').rangeslider('update', true);
    this.calculate();
  }

  initializeInputValueUpdateProcess() {
    $(document).on('input', 'input[type="range"]', this.onRangeInput.bind(this));
    this.isChampagneToastCheckbox.addEventListener('change', this.calculate.bind(this));
    this.numberOfGuestsInput.addEventListener('change', this.onNumberOfGuestsChange.bind(this));
    this.eventLengthInput.addEventListener('change', this.calculate.bind(this));
    this.formatHours(1);
  }

  onNumberOfGuestsChange() {
    if (this.numberOfGuestsInput.value > 2000) {
      this.numberOfGuestsInput.value = 2000;
    }

    this.calculate();
  }

  initializeCustomRangeComponent() {
    $('input[type="range"]').rangeslider({
      polyfill: false,
    });
  }

  calculate() {
    const numberOfGuests = parseInt(this.numberOfGuestsInput.value);

    if (isNaN(numberOfGuests)) {
      this.resultsPlaceholderBeerCount.innerHTML = '#';
      this.resultsPlaceholderWineCount.innerHTML = '#';
      this.resultsPlaceholderSpiritsCount.innerHTML = '#';
      this.resultsPlaceholderChampagneCount.innerHTML = '#';
      this.resultsPlaceholderTotalDrinks.innerHTML = '#';
      this.resultsPlaceholderDrinksPerGuest.innerHTML = '#';

      this.resultsPlaceholderChampagneCount.parentNode.style.display = 'none';
      return;
    }

    const eventLength = parseInt(this.eventLengthInput.value);
    const winePercentage = parseInt(this.wineAmountInput.value) / 100;
    const beerPercentage = parseInt(this.beerAmountInput.value) / 100;
    const spiritsPercentage = parseInt(this.spiritsAmountInput.value) / 100;
    const isChampagneToast = this.isChampagneToastCheckbox.checked;

    let drinksPerHour = eventLength + 1;
    let drinksTotal = numberOfGuests * drinksPerHour;

    const wineCount = Math.ceil(numberOfGuests * drinksPerHour * winePercentage / 5);
    const beerCount = Math.ceil(numberOfGuests * drinksPerHour * beerPercentage / 6);
    const spiritCount = Math.ceil(numberOfGuests * drinksPerHour * spiritsPercentage / 16);

    let champagneCount = 0;

    if (isChampagneToast) {
      champagneCount = Math.ceil(numberOfGuests / 5);
      drinksTotal = drinksTotal + numberOfGuests;
      drinksPerHour = drinksPerHour + 1;
    }

    this.resultsPlaceholderBeerCount.innerHTML = beerCount;
    this.resultsPlaceholderWineCount.innerHTML = wineCount;
    this.resultsPlaceholderSpiritsCount.innerHTML = spiritCount;
    this.resultsPlaceholderChampagneCount.innerHTML = champagneCount;
    this.resultsPlaceholderTotalDrinks.innerHTML = drinksTotal;
    this.resultsPlaceholderDrinksPerGuest.innerHTML = drinksPerHour;

    this.resultsPlaceholderChampagneCount.parentNode.style.display = !isChampagneToast ? 'none' : '';
  }

  formatHours(hours) {
    return hours === 1 ? 'hr' : 'hrs';
  }
}

customElements.define('drink-calculator', DrinkCalculator);
